// They can't be directly imported from the 3d core library because
// we only need them when we load the babylon, etc scripts.
// We could do some fancy things with dynamic imports, but to simplify I'm justing
// redefine them here.
export enum TryOnSettingsType {
    VirtualTryOn = 'try_on',
    GlassPupillaryDistanceTool = 'pd',
    StyleButton = 'styleButton',
    MandatoryPupillaryDistance = 'mandatoryPD'
}

export enum TryOnType {
    NotSelected = 0,
    Eyewear = 1,
    Scarves = 2,
    Earrings = 3,
    Headwear = 4,
    Necklace = 5,
    Shoes = 6,
    Watches = 7,
    Bracelet = 8
}

export const tryOnGraphqlMap = new Map([
    [TryOnType.Eyewear, 'EYEWEAR'],
    [TryOnType.Scarves, 'SCARVES'],
    [TryOnType.Earrings, 'EARRINGS'],
    [TryOnType.Headwear, 'HEADWEAR'],
    [TryOnType.Necklace, 'NECKLACE'],
    [TryOnType.Shoes, 'SHOES'],
    [TryOnType.Watches, 'WATCHES'],
    [TryOnType.Bracelet, 'BRACELET']
]);
export type TryOnProvidersTypesMappingList = {
    key: number;
    value: number;
}[];
export type TryOnProvidersTypesMapping = {
    list: TryOnProvidersTypesMappingList;
};
export enum TryOnProvider {
    NotSelected = 0,
    Mazing = 1,
    Banuba = 2,
    DeepAR = 3
}
export interface TryOnInfo {
    mapping: TryOnProvidersTypesMapping;
}

// Reverse
export const tryOnGraphqlMapReverse = new Map(Array.from(tryOnGraphqlMap.entries()).map(([k, v]) => [v, k]));
